import { Component } from '@angular/core';
import { NgxAimProductsComponent } from 'ngx-aim';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aim-products',
  standalone: true,
  styleUrls: ['./products.component.scss'],
  imports: [NgxAimProductsComponent],
  template: '<ngx-aim-products class="product-container"></ngx-aim-products>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsComponent {}
